// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__header-eac1f5 {
  margin-bottom: 4px;
}

.Header__header-eac1f5.Header__forward-aacd3f {
  padding: 8px 12px 0;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/StickerBubble/Header/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".header {\n  margin-bottom: 4px;\n}\n\n.header.forward {\n  padding: 8px 12px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header__header-eac1f5`,
	"forward": `Header__forward-aacd3f`
};
module.exports = ___CSS_LOADER_EXPORT___;
